import CONSTANTS from 'utils/constants'

/**
 * Public Google Maps HTTP endpoints (not secrets). Keys stay in env via {@link CONSTANTS}.
 * @see https://developers.google.com/maps/documentation/embed/embedding-map
 * @see https://developers.google.com/maps/documentation/maps-static/overview
 */
export const GOOGLE_MAPS_EMBED_V1_PLACE_BASE_URL =
  'https://www.google.com/maps/embed/v1/place'

export const GOOGLE_MAPS_STATIC_MAP_BASE_URL =
  'https://maps.googleapis.com/maps/api/staticmap'

/** Google's static map centred on, and marking, a point. */
export const staticMapUrl = (latitude: number, longitude: number): string => {
  const point = `${latitude},${longitude}`
  const url = new URL(GOOGLE_MAPS_STATIC_MAP_BASE_URL)
  url.search = new URLSearchParams({
    center: point,
    key: CONSTANTS.VITE_REACT_APP_GOOGLE_MAPS_API_KEY,
    markers: point,
    size: '600x300',
    zoom: '19'
  }).toString()
  return url.toString()
}

/** Whether `src` points at Google's static map endpoint and nowhere else. */
export const isStaticMapUrl = (src: string): boolean => {
  try {
    const url = new URL(src)
    const staticMap = new URL(GOOGLE_MAPS_STATIC_MAP_BASE_URL)
    return (
      url.origin === staticMap.origin && url.pathname === staticMap.pathname
    )
  } catch {
    return false
  }
}
